module.exports = __webpack_public_path__ + "static/media/nigel-hembrow-pic.ea9756bc.png";